import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ImageGenerate = _resolveComponent("ImageGenerate");
  return _openBlock(), _createBlock(_component_ImageGenerate, {
    headImgUrl: $options.headImg,
    carousel_01: $options.carouselImages[0],
    carousel_02: $options.carouselImages[1],
    carousel_03: $options.carouselImages[2],
    carousel_04: $options.carouselImages[3],
    carousel_05: $options.carouselImages[4],
    carousel_06: $options.carouselImages[5],
    ex_original: $options.exampleOriginal,
    ex_target: $options.exampleTarget,
    shopUrl: $options.shopUrl,
    productName: $options.productName,
    widthheight_ratio: $options.widthHeightRatio,
    product_introduce: $options.productIntroduce,
    crop_shape_square_image: $options.cropShapeSquareObject,
    crop_shape_horizontal_image: $options.cropShapeHorizontalObject,
    crop_shape_vertical_image: $options.cropShapeVerticalObject
  }, null, 8, ["headImgUrl", "carousel_01", "carousel_02", "carousel_03", "carousel_04", "carousel_05", "carousel_06", "ex_original", "ex_target", "shopUrl", "productName", "widthheight_ratio", "product_introduce", "crop_shape_square_image", "crop_shape_horizontal_image", "crop_shape_vertical_image"]);
}